import { Button } from "./button.js";
import { ThemeToggle } from "./theme-toggle.js";

const publicLinks = [
  { href: "/", label: "Home" },
  { href: "/services", label: "Services" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

const adminLinks = [{ href: "/", label: "Dashboard" }];

function isActive(href, currentPath) {
  if (href === "/") return currentPath === "/";
  return currentPath === href || currentPath.startsWith(`${href}/`);
}

function navLink({ href, label }, currentPath) {
  const active = isActive(href, currentPath);
  const classes = active
    ? "text-accent"
    : "text-white/80 hover:text-accent dark:text-text-dark dark:hover:text-accent";

  return `<a href="${href}" data-link class="${classes} text-sm font-medium transition">${label}</a>`;
}

export function Header(variant = "public", currentPath = "/") {
  const links = variant === "admin" ? adminLinks : publicLinks;
  const cta =
    variant === "admin"
      ? `<button type="button" id="logout-button" class="text-sm font-semibold text-white/80 transition hover:text-accent">Logout</button>`
      : Button({ label: "Track Shipment", variant: "accent", href: "/track", className: "px-4 py-2" });

  return `
    <header class="sticky top-0 z-40 border-b border-white/10 bg-primary text-white shadow-sm dark:border-border-dark dark:bg-bg-dark">
      <div class="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a href="/" data-link class="flex min-w-0 items-center gap-3" aria-label="Pinaroyalcargo home">
          <img src="/brand/light_logo_no_tagline.png" alt="Pinaroyalcargo" class="h-12 w-auto max-w-[235px] object-contain sm:h-14 sm:max-w-[280px]" />
        </a>

        <nav class="hidden items-center gap-8 md:flex" aria-label="Primary navigation">
          ${links.map((link) => navLink(link, currentPath)).join("")}
        </nav>

        <div class="hidden items-center gap-3 md:flex">
          ${cta}
          ${ThemeToggle()}
        </div>

        <button
          id="mobile-menu-toggle"
          type="button"
          class="inline-flex h-10 w-10 items-center justify-center rounded border border-white/20 text-white md:hidden"
          aria-label="Open menu"
          aria-expanded="false"
        >
          <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div id="mobile-menu" class="hidden border-t border-white/10 px-4 pb-4 md:hidden">
        <nav class="flex flex-col gap-3 pt-4" aria-label="Mobile navigation">
          ${links.map((link) => navLink(link, currentPath)).join("")}
          <div class="flex items-center gap-3 pt-2">
            ${cta}
            ${ThemeToggle({ id: "theme-toggle-mobile" })}
          </div>
        </nav>
      </div>
    </header>
  `;
}

export function mountHeader(root = document) {
  const toggle = root.querySelector("#mobile-menu-toggle");
  const menu = root.querySelector("#mobile-menu");
  if (!toggle || !menu) return;

  toggle.addEventListener("click", () => {
    const isOpen = !menu.classList.toggle("hidden");
    toggle.setAttribute("aria-expanded", String(isOpen));
    toggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
  });
}
